import { render, staticRenderFns } from "./stockbatch_list.vue?vue&type=template&id=9def22b4&scoped=true"
import script from "./stockbatch_list.vue?vue&type=script&lang=js"
export * from "./stockbatch_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9def22b4",
  null
  
)

export default component.exports